<template>
  <AppTooltip>
    <template #activator="{ props }">
      <AppButton class="ml-1"
                icon
                small
                v-bind="props"
      >
        <app-icon-ds
          icon="paperclip"
          size="xs"
          weight="fal"
        />
      </AppButton>
    </template>
    <div>
      {{ $t('project.checklist.dialogs.SaveChecklistFromTemplateDialog.checklistPreview.attachments') }}
      <ul>
        <li v-for="(fileName, index) in task.attachments" :key="`attachment-${index}`">
          {{ fileName }}
        </li>
      </ul>
    </div>
  </AppTooltip>
</template>

<script>
  import AppTooltip from '@/common/AppTooltip.vue'
  import AppButton from '@/common/buttons/AppButton.vue'

  export default {
    name: 'SavedChecklistPreviewAttachments',
    components: {
      AppButton,
      AppTooltip,
    },
    props: {
      task: {
        type: Object,
        required: true,
      },
    },
  }
</script>
